import { render, staticRenderFns } from "./ThemeSettingsDirectTopTef.vue?vue&type=template&id=2920c9f8&scoped=true"
import script from "./ThemeSettingsDirectTopTef.vue?vue&type=script&lang=js"
export * from "./ThemeSettingsDirectTopTef.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2920c9f8",
  null
  
)

export default component.exports